import React from 'react';

import { Svg, useSvgColor } from '~/assets/icons/styles';

const LockOpenedIcon = ({ color = '', ...rest }) => {
  const svgColor = useSvgColor(color);
  return (
    <Svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={svgColor}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.72703 22.227C9.9929 20.9612 11.7098 20.25 13.5 20.25H40.5C42.2902 20.25 44.0071 20.9612 45.273 22.227C46.5388 23.4929 47.25 25.2098 47.25 27V45C47.25 46.7902 46.5388 48.5071 45.273 49.773C44.0071 51.0388 42.2902 51.75 40.5 51.75H13.5C11.7098 51.75 9.9929 51.0388 8.72703 49.773C7.46116 48.5071 6.75 46.7902 6.75 45V27C6.75 25.2098 7.46116 23.4929 8.72703 22.227ZM13.5 24.75C12.9033 24.75 12.331 24.9871 11.909 25.409C11.4871 25.831 11.25 26.4033 11.25 27V45C11.25 45.5967 11.4871 46.169 11.909 46.591C12.331 47.0129 12.9033 47.25 13.5 47.25H40.5C41.0967 47.25 41.669 47.0129 42.091 46.591C42.5129 46.169 42.75 45.5967 42.75 45V27C42.75 26.4033 42.5129 25.831 42.091 25.409C41.669 24.9871 41.0967 24.75 40.5 24.75H13.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 31.5C28.2426 31.5 29.25 32.5074 29.25 33.75V38.25C29.25 39.4926 28.2426 40.5 27 40.5C25.7574 40.5 24.75 39.4926 24.75 38.25V33.75C24.75 32.5074 25.7574 31.5 27 31.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3895 0C22.2124 0 18.2063 1.65937 15.2526 4.61307C13.5034 6.36224 12.9802 7.64133 11.6449 10.5707C11.4248 11.0537 11.6168 11.6266 12.0855 11.8756L14.1732 12.9846C14.6937 13.261 15.3418 13.0308 15.5892 12.4958C16.2024 11.1696 17.3536 8.87604 18.4346 7.79505C20.5444 5.68526 23.4058 4.5 26.3895 4.5C29.3732 4.5 32.2347 5.68526 34.3445 7.79505C36.4543 9.90483 37.6395 12.7663 37.6395 15.75L37.5265 24.75C39.328 24.75 40.338 24.75 42.1395 24.75V15.75C42.1395 11.5728 40.4801 7.56677 37.5265 4.61307C34.5728 1.65937 30.5667 0 26.3895 0Z"
        fill="currentColor"
      />
    </Svg>
  );
};

export default LockOpenedIcon;
